import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Lock, Zap } from 'lucide-react';
import { trackEvent } from './utils/metaPixel';
export function FinalCTA() {
  return <section className="py-32 bg-surface relative overflow-hidden" data-id="element-66">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-neural-pattern opacity-40" data-id="element-67"></div>
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-64 bg-accent/10 blur-[100px] pointer-events-none" data-id="element-68"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10 text-center" data-id="element-69">
        <FadeIn data-id="element-70">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background border border-accent/30 text-accent font-semibold mb-8 shadow-[0_0_20px_rgba(212,168,83,0.15)]" data-id="element-71">
            <Zap className="w-5 h-5" data-id="element-72" />
            <span data-id="element-73">Obtén acceso inmediato ahora</span>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-74">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-black text-white mb-12 leading-tight" data-id="element-75">
            Empieza a leer mentes <br className="hidden sm:block" data-id="element-76" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-accent-light" data-id="element-77">
              hoy mismo.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-78">
          <div className="flex flex-col items-center justify-center gap-6" data-id="element-79">
            <CTAButton href="https://omnilectura.com/cart/48175231566049:1" onClick={() => trackEvent('Purchase', {
            content_name: 'La Mente Al Desnudo',
            value: 19.0,
            currency: 'USD'
          })} className="w-full sm:w-auto sm:px-12 sm:py-6 text-xl sm:text-2xl" data-id="element-80" />

            <div className="flex items-center gap-2 text-slate-400 mt-4 bg-background/50 px-6 py-3 rounded-full border border-white/5 backdrop-blur-sm" data-id="element-81">
              <Lock className="w-4 h-4 text-accent" data-id="element-82" />
              <p className="text-sm sm:text-base font-medium" data-id="element-83">
                Recibe el PDF en tu correo un segundo después de la compra.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}